import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
    Button,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    AccordionActions,
    Divider
} from "@material-ui/core";
import SimpleInputComment from "../../components/Frequents/SimpleInputComment";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PremiumBadge from "../../components/Frequents/PremiumBadge";
import ReactToPrint from "react-to-print";
import NewCustomField from "./NewCustomField.js";
import moment from "moment";
import API from "../../actions";
import update from "immutability-helper";

export default props => {
    const printRef = useRef();
    const therapist = useSelector(state => state.data.therapist);

    const [stamJournal, setStamJournal] = useState("");
    const [client, setClient] = useState("");

    const changeValueStamJournal = (type, id) => async value => {
        const sj = update(stamJournal, { [id]: { [type]: { $set: value } } });

        const cC = update(client, {
            updatedBySJ: { $set: therapist.nameFirst + " " + therapist.nameLast }
        });

        setStamJournal(sj);
        setClient(cC);
        // console.log('changeValueStamJournal', type, id, sj);
        await API.setCustomFields(props.clickedClient.id, [sj[id]]);
        await API.setClient(cC);
    };

    const clearDupes = stam => {
        const l = [];
        for (let i = 0; i < stam.length; i++) {
            if (stam[i].locked === false || !l.map(field => field.name).includes(stam[i].name)) {
                l.push(stam[i]);
                continue;
            }
            if (stam[i].value) l[l.findIndex(e => e.name === stam[i].name)] = stam[i];
        }
        return l;
    };

    useEffect(() => {
        (async () => {
            if (props.stamJournal) setStamJournal(await clearDupes(props.stamJournal));
            setClient(props.clickedClient);
        })();

    }, [props.stamJournal, props.clickedClient]);

    if (!therapist) return <></>;

    const getCanEditDataStatus = (obj, field) => {
        if (!obj[field]) {
            return true;
        }

        const endTime = new Date(obj[field]).getTime();
        return new Date().getTime() < +endTime + 86400000;
    };

    return (
        <Accordion expanded={props.expanded === "stamjournal"} ref={printRef}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="stamjournal-content"
                id="stamjournal-header"
                onClick={props.expand}>
                <div>
                    <Typography>
                        Stamjournal fra {moment(new Date(props.clickedClient.createdAt)).format("DD/MM/YYYY")}
                        {" sidst rettet " + moment(new Date(props.stamJournalUpdate)).format("DD/MM/YYYY")}
                        {client.updatedBySJ ? " - " + client.updatedBySJ : props.clickedClient.updatedBy ? " - " + props.clickedClient.updatedBy : ''}
                    </Typography>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{ width: "100%" }}>
                    {props.clickedClient &&
                        (!stamJournal ||
                            stamJournal.map((felter, index) => {
                                // console.log('stamJournal', felter);
                                return (
                                    <>
                                        <SimpleInputComment
                                            canEditData={getCanEditDataStatus(felter, 'firstInputValueDate')}
                                            id={felter.customFieldId}
                                            felter={felter}
                                            therapist={therapist}
                                            name={felter.name}
                                            key={"stamjournal" + index + props.clickedClient.id}
                                            multiline={true}
                                            text={felter.name}
                                            prop={felter.value}
                                            changeValue={changeValueStamJournal("value", index)}
                                            clickedClient={props.clickedClient}
                                            enableComment={index < 4}
                                            updatedAt={felter.updatedAt}
                                            comments={felter.comments}
                                            customFieldId={felter.customFieldId}
                                        />
                                        {!felter.locked && therapist.plan === "pro" && props.canEditData ? (
                                            <NewCustomField
                                                key={"stamjournal-1" + index + props.clickedClient.id}
                                                new={false}
                                                felter={felter}
                                                clientId={props.clickedClient.id}
                                                update={async item => setStamJournal(await clearDupes(item))}
                                            />
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                );
                            }))}
                </div>
            </AccordionDetails>
            <Divider />
            <AccordionActions>
                <ReactToPrint trigger={() => <Button size="small">Print</Button>} content={() => printRef.current} />
                <Button size="small" onClick={props.expand}>
                    Luk
                </Button>
                {props.canEditData !== false ? (
                    <NewCustomField
                        new={true}
                        update={async item => setStamJournal(await clearDupes(item))}
                        pro={therapist.plan === "pro"}
                        clientId={props.clickedClient.id}
                    />
                ) : (
                    <></>
                )}
                {therapist.plan !== "pro" && <PremiumBadge />}
            </AccordionActions>
        </Accordion>
    );
};
